import React from "react";
import { useState } from "react";
import INTOUCH_API from "../../services/Api";
import useModalActions from "../../hooks/useModalActions";
import { MODAL_TYPES } from "../../utils/emitter";

export default function useController() {
  const [isFeedbackLoading, setIsFeedbackLoading] = useState(false);
  const [reviewValue, setReviewValue] = useState("");
  const { openModal } = useModalActions();
  const onSubmitHandle = async () => {
    if (isFeedbackLoading) return;
    setIsFeedbackLoading(true);
    await INTOUCH_API.requestManager(
      "feedback",
      { text: reviewValue },
      () => {
        setReviewValue("");
        openModal(MODAL_TYPES.FEEDBACK_SENDED);
      },
      () => {}
    ).finally(() => {
      setIsFeedbackLoading(false);
    });
  };

  return {
    reviewValue,
    setReviewValue,
    onSubmitHandle,
    isFeedbackLoading,
  };
}
